<mat-tab-group animationDuration="0ms" disableRipple="true">
  <mat-tab label="Documentación">
    <app-tabla-documentacion></app-tabla-documentacion>
  </mat-tab>
  <mat-tab label="Instalaciones">
    <app-tabla-instalaciones></app-tabla-instalaciones>
  </mat-tab>
  <mat-tab label="Clientes">
    <app-tabla-clientes></app-tabla-clientes>
  </mat-tab>
  <mat-tab label="Centros">
    <app-tabla-centros></app-tabla-centros>
  </mat-tab>
  <mat-tab label="Contratistas">
    <app-tabla-contratistas></app-tabla-contratistas>
  </mat-tab>
  <mat-tab label="Gestores">
    <app-tabla-gestores></app-tabla-gestores>
  </mat-tab>
  <mat-tab label="Transportistas">
    <app-tabla-transportistas></app-tabla-transportistas>
  </mat-tab>
</mat-tab-group>
